export default __webpack_public_path__ + "static/media/Avatar-25-noback.4c46be20.png";